export interface CapabilityCatalogEntry {
  capability: string;
  preferredWorker: string;
  provider:
    | "internal"
    | "github"
    | "supabase"
    | "cloudflare"
    | "browser"
    | "terminal"
    | "filesystem";
}

export const CYAN_CAPABILITY_CATALOG: readonly CapabilityCatalogEntry[] = [
  {
    capability: "project-intake",
    preferredWorker: "cyan-project-intake",
    provider: "internal",
  },

  {
    capability: "spec-read",
    preferredWorker: "filesystem-worker",
    provider: "filesystem",
  },

  {
    capability: "memory-read",
    preferredWorker: "cyan-memory-runtime",
    provider: "internal",
  },

  {
    capability: "connection-discovery",
    preferredWorker: "cyan-capability-runtime",
    provider: "internal",
  },

  {
    capability: "analysis",
    preferredWorker: "cyan-reasoning",
    provider: "internal",
  },

  {
    capability: "gap-detection",
    preferredWorker: "cyan-reasoning",
    provider: "internal",
  },

  {
    capability: "mutation-planning",
    preferredWorker: "mutation-planner",
    provider: "internal",
  },

  {
    capability: "verification-planning",
    preferredWorker: "browser-verifier",
    provider: "browser",
  },

  {
    capability: "execution-queue",
    preferredWorker: "job-service",
    provider: "internal",
  },

  {
    capability: "technology-worker",
    preferredWorker: "technology-worker-runtime",
    provider: "internal",
  },

  {
    capability: "tests",
    preferredWorker: "terminal-worker",
    provider: "terminal",
  },

  {
    capability: "build",
    preferredWorker: "terminal-worker",
    provider: "terminal",
  },

  {
    capability: "browser-verification",
    preferredWorker: "playwright-browser-driver",
    provider: "browser",
  },

  {
    capability: "runtime-observation",
    preferredWorker: "observability-runtime",
    provider: "internal",
  },

  {
    capability: "github-read",
    preferredWorker: "github-read-adapter",
    provider: "github",
  },

  {
    capability: "supabase-read",
    preferredWorker: "supabase-read-adapter",
    provider: "supabase",
  },

  {
    capability: "cloudflare-read",
    preferredWorker: "cloudflare-read-adapter",
    provider: "cloudflare",
  },
];

export function findCapabilityCatalogEntry(
  capability: string,
): CapabilityCatalogEntry | undefined {
  return CYAN_CAPABILITY_CATALOG.find(
    (entry) => entry.capability === capability,
  );
}
